import { Card, SimpleGrid, } from "@mantine/core";
import { DynamicComponent, type DynamicQuestionProp } from "./index";
import type { ExitQuestion } from "@/testmeta.types";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useMap } from '@mantine/hooks';


export interface DynamicFormProps {
    components: ExitQuestion[];
}

export interface DynamicFormRef {
    getValues: () => {
        [key: string]: string | boolean | number | string[] | number[] | undefined;
    };
}

export const DynamicForm = forwardRef<DynamicFormRef, DynamicFormProps>(({ components }, ref) => {
    const inputMap = useMap();
    const [dynamicComps, setDynamicComps] = useState<DynamicQuestionProp[]>([]);
    useEffect(()=>{
        if(!components) {
            setDynamicComps([]);
            return;
        }
        // update internal state
        setDynamicComps(components.map(comp => ({
            ...comp,
            setValue: (value: string | boolean | number | string[] | number[] | undefined) => {
                inputMap.set(comp.label, value);
            }
        })));
    }, [components, inputMap])

    useImperativeHandle(ref, () => ({
        getValues: () => {
            return Object.fromEntries(inputMap.entries());
        }
    }), [inputMap]);
    return <Card m={8}>
        <SimpleGrid cols={{ base: 1, md: 2 }} w='500px'>
            {dynamicComps.map((comp, index) => {
                const { key, ...compProps } = comp;
                return <DynamicComponent key={key || `${comp.label}-${index}`} {...compProps} />
            })}
        </SimpleGrid>
    </Card>
});